import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../Base/Services/Moment/Luxon";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";
import { getComprobanteCajaChicaEnc } from "../../../API/Finanzas/CajaChica/BoletaCompraRequest";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { SplitButton } from "primereact/splitbutton";
import ComprobanteCRUD from "./ComprobanteCRUD";

// ------------------- CONSULTAS A LA API---------------------------


// ------------------ COMPONENTES DE NECESARIOS--------------------------



const ComprobanteCajaChicaScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedEnc, setSelectedEnc] = useState([]);
  const [selectedDet, setSelectedDet] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const [IdCurrency, setIdCurrency] = useState(2);


  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    let dataTempo
    if(activeIndex === 0){
        dataTempo = await getComprobanteCajaChicaEnc(fechas)
    }else{
        dataTempo = await getComprobanteCajaChicaEnc(fechas)
    }
    setLoading(false);
  };

  const ejecularEliminar = (selectedEnc) => {
    confirmDialog({
      message: selectedEnc.length > 1 ? "¿Estás seguro de eliminar los pases de salida?" : "¿Estás seguro de eliminar el pase de salida?",
      header: "Eliminar Pase de Salida",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        eliminarPase(selectedEnc)
      },
      rejectLabel: "No",
      reject: () => {}, 
      style: { backgroundColor: "white" },
    });
  };

  const eliminarPase = async (selectedEnc) =>{
    // selectedEnc.forEach(async (select) => {
    //   if(select.IdEstado === 61 || select?.IdEstado === 62){
    //     toastShow( toast, "error", "Error al eliminar", select.IdEstado === 61 ? "El pase de salida ya esta completado" : 'El pase de salida está en "Pendiente Retorno" ' );
    //   }else{
    //     const respuesta = await EliminarPase(select)
    //   }
    // })
    // toastShow( toast, "success", "Eliminado", selectedEnc.length > 1 ? "Pases de salida eliminados correctamente" : 'Pase de salida eliminado correctamente' );
    // getInfo()
    // setSelectedEnc([])
  }

  const ejecularEliminarDet = (selectedDet) => {
    confirmDialog({
      message: selectedDet.length > 1 ? "¿Estás seguro de eliminar los detalle del pase?" : "¿Estás seguro de eliminar el detalle del pase?",
      header: "Eliminar Detalle",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        eliminarPaseDet(selectedDet)
      },
      rejectLabel: "No",
      reject: () => {},
      style: { backgroundColor: "white" },
    });
  };

  const eliminarPaseDet = async (selectedDet) =>{
    // selectedDet.forEach(async (select) => {
    //   if(select.IdEstadoEnc === 61 || select?.IdEstadoEnc === 62){
    //     toastShow( toast, "error", "Error al eliminar", select.IdEstado === 61 ? "El pase de salida ya esta completado" : 'El pase de salida está en "Pendiente Retorno" ' );
    //   }else{
    //     const respuesta = await EliminarPaseDetalle(select)
    //   }
    // })
    // toastShow( toast, "success", "Eliminado", selectedDet.length > 1 ? "Detalles de pases de salida eliminados correctamente" : 'Detalle de pase de salida eliminado correctamente' );
    // getInfo()
    // setSelectedDet([])
  }
  
  const columns = [
    {
      field: "IdComprobante",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdComprobante > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "FechaEmisionStr",
      header: "Fecaha Emisión",
      headerEn: "Date Emission",
      Format: "Date",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "NumeroBoletaCompra",
      headerEn: "No. Boleta",
      header: "No. Boleta",
      frozen: 1,
      className: "medium",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdComprobante > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "medium",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "XXXlarge",
    },
    {
      field: "NombreCuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXlarge",
    },
    {
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "small",
    },
    {
      field: "OrdenCompra",
      header: "Orden de Compra",
      headerEn: "Purchase Order",
      className: "medium",
    },
    {
      field: "ConstanciaRegistro",
      header: "Constancia de Registro",
      headerEn: "Registration Certificate",
      className: "medium",
    },
    {
      field: "RegistroSAG",
      header: "Registro SAG",
      headerEn: "SAG Registration",
      className: "medium",
    },
    {
      header: "Comentario",
      headerEn: "Comment",
      field: "Comentario",
      minWidth: 300,
    },
    {
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Rate Change",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "TotalL",
      header: "Total L",
      headerEn: "Total L",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "TotalD",
      header: "Total $",
      headerEn: "Total $",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "IdComprobante",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdComprobante > 0) {
              setShowDialog(true);
              setSelectedEnc([rowData]);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    loading: loading,
    selected: selectedEnc,
    setSelected: setSelectedEnc,
    showModal: () => {},
  };

  const items = [
    {
      label: "Lempiras",
      command: () => {
        setShowDialog(true)
        setIdCurrency(2)
      },
    },
    {
      label: "Dólares",
      command: () => {
        setShowDialog(true)
        setIdCurrency(1)
      },
    },
  ];

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "ComprobantesCajaChica", config.language));
  }, [activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <CalendarioOperativo
                dates={dates}
                setDates={setDates}
                loading={loading}
                getInfo={getInfo}
            />

            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            <SplitButton
                icon="pi pi-plus"
                tooltip="Nueva"
                model={items}
            />

            <Button
                icon="pi pi-times"
                type="button"
                className="p-button-danger listado__botones"
                tooltip="Eliminar"
                style={{ marginLeft: 1.5 }}
                disabled={activeIndex === 0 ? selectedEnc.length <= 0 : selectedDet <= 0}
                onClick={() => {
                    if(activeIndex === 0){
                    //ELIMINAR PASE COMPLETO
                    if(selectedEnc.length <= 0){
                        toastShow(toast,"warn","Advertencia","Seleccione al menos un pase de salida.");
                    }else{
                        ejecularEliminar(selectedEnc)
                    }

                    }else{
                    //ELIMINAR DETALLE
                    if(selectedDet.length <= 0){
                        toastShow(toast,"warn","Advertencia","Seleccione al menos un detalle de pase de salida.");
                    }else{
                        ejecularEliminarDet(selectedDet)
                    }
                    }
                }}
            />

          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >

                <TabPanel header="Comprobantes Pendientes de Cierre">
                    <div style={{height: '85vh'}}>
                        <AgGrid table={table} />
                    </div>
                </TabPanel>
                
                <TabPanel header={'Comprobantes de Caja Chica'}>
                    <div style={{height: '85vh'}}>
                        <AgGrid table={table} />
                    </div>
                </TabPanel>

            </TabView>
          </div>
        }
      />

      {showDialog &&(
        <ComprobanteCRUD
            showDialog={showDialog}
            setShowDialog={setShowDialog}
            selectedEnc={selectedEnc}
            setSelectedEnc={setSelectedEnc}
            getInfo={getInfo}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
            IdCurrency={IdCurrency}
        />
      )}
    </div>
  );
};

export default ComprobanteCajaChicaScreen;
